import React, {useState, useRef, useEffect} from "react";

const WarmthIndicator = (props) => {

  return (
    <div className="warmthIndicator__warmth-indicator">
			<h6 className="warmthIndicator__title">warmth</h6>
			<div className="warmthIndicator__warmth-holder">
				{Array.from({ length: props.indicator_value }, (_, index) => (
					<div key={index} className="warmthIndicator__warmth">
						<div className="warmthIndicator__warmth__item"></div>
					</div>
				))}
			</div>

		</div>
  );
};

export default WarmthIndicator;
